module.exports = __webpack_public_path__ + "images/favicon-8e8385336a4211dcdfee543257d23421.ico";